<template>
  <div class="jigsaw_passed">
     <van-overlay :show="passedShow">
        <div class="jigsaw_passed_wraper">
           <img src="@/assets/images/game/close.png" @click="goback" class="jigsaw_passed_wraper_close" />
           <img src="../../assets/images/jigsaw/pass.png" class="jigsaw_passed_wraper_pic">
           <img src="../../assets/images/jigsaw/pass-child.png" class="jigsaw_passed_wraper_cartoon">
           <div class="jigsaw_passed_wraper_button">
               <div class="jigsaw_passed_wraper_button_no" @click.stop="goback">
                     返回关卡
               </div>
               <div class="jigsaw_passed_wraper_button_yes" @click.stop="next" v-if="nextFlag" >
                     下一关
               </div>
            </div>
        </div>
     </van-overlay>
  </div>
</template>

<script>
export default {
   name:"passed-dialog",
   props:{
      passedShow:{
         type:Boolean
      },
      nextFlag:{
         type:Boolean
      },
   },
   data() {
      return {
         // nextFlag:true
      }
   },
   watch:{

   },
   created(){},
   mounted() {},
   methods:{
      next() {
         this.$emit('next')
      },
      goback() {
         this.$emit('goBack')
      },
   }
}
</script>

<style lang="scss" scoped>
.van-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    .jigsaw_passed_wraper{
       position: relative;
       .jigsaw_passed_wraper_close {
            position: absolute;
            width: 26px;
            height: 26px;
            right: -26px;
            top: 37px;
       }
       .jigsaw_passed_wraper_pic{
          width:224px;
          height:181px;
       }
       .jigsaw_passed_wraper_cartoon{
          width:77px;
          height:109px;
          position: absolute;
          top:57px;
          left:-18px;
       }
       .jigsaw_passed_wraper_button{
            display: flex;
            justify-content: center;
            .jigsaw_passed_wraper_button_no {
                width: 86px;
                height: 31px;
                background: url(./../../assets/images/game/no.png);
                background-size: cover;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 31px;
                text-shadow: 0px 2px 1px #6381FF;
                text-align: center;
            }
            .jigsaw_passed_wraper_button_yes {
                width: 86px;
                height: 31px;
                background: url(./../../assets/images/game/yes.png);
                background-size: cover;
                margin-left: 12px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 31px;
                text-shadow: 0px 2px 1px #fe8c62;
                text-align: center;
            }
       }
    }
}
</style>